import "kendo.core";
import "kendo.data";

import { AUTH_TOKEN, ENDPOINTS } from "../config/elasticsearch";
import { dateInMilliseconds, dateFormatter, errorHandler } from "../utils";

const url = ENDPOINTS.ICD;

class DataSource {
  constructor({
    serverFiltering = true,
    diagCode = null,
    thruDate = null,
  } = {}) {
    this.serverFiltering = serverFiltering;
    this.diagCode = diagCode;
    this.thruDate = thruDate;

    this.ds = new kendo.data.DataSource({
      serverFiltering: this.serverFiltering,
      transport: this.getTransport(),
      schema: this.getSchema(),
      error: errorHandler,
    });

    return this.ds;
  }

  getTransport() {
    return {
      read: {
        url,
        contentType: "application/json",
        dataType: "json",
        type: "POST",
        beforeSend: (jqXHR) => {
          // inject auth header
          jqXHR.setRequestHeader("Authorization", AUTH_TOKEN);
        },
      },
      parameterMap: () => kendo.stringify(this.getCriteria()),
    };
  }

  getSchema() {
    return {
      type: "json",
      total: "hits.total",
      data: "hits.hits",
      model: kendo.data.Model.define({
        fields: {
          score: { type: "number", from: "_score" },
          code: { type: "string", from: "_source.code" },
          desc: { type: "string", from: "_source.desc" },
        },
      }),
    };
  }

  getCriteria() {
    const criteria = {
      query: $(this.diagCode).getKendoAutoComplete().value().trim() || null,
      thruDate: $(this.thruDate).val().trim() || null,
    };

    return this.prepareQuery(criteria);
  }

  prepareQuery({ query = "*", thruDate = dateFormatter(moment()) } = {}) {
    // prepare data
    const data = {
      size: 30,
      query: {
        bool: {
          must: {
            query_string: {
              query,
            },
          },
          filter: [
            {
              range: {
                valid_from_date: {
                  lte: dateInMilliseconds(thruDate),
                },
              },
            },
            {
              range: {
                valid_thru_date: {
                  gte: dateInMilliseconds(thruDate),
                },
              },
            },
          ],
        },
      },
      aggs: {
        from_dates: {
          terms: {
            field: "valid_from_date",
            order: {
              _term: "asc",
            },
          },
        },
        thru_dates: {
          terms: {
            field: "valid_thru_date",
            order: {
              _term: "asc",
            },
          },
        },
      },
    };

    return data;
  }
}

export { DataSource as default };
